import { noop } from 'lodash';
import { Key } from 'react';

import { createContext } from 'use-context-selector';

interface FormCheckboxGroupContextProps {
  values: Key[];
  onChange: (v: Key[]) => void;
}

export const FormCheckboxGroupContext =
  createContext<FormCheckboxGroupContextProps>({
    values: [],
    onChange: noop,
  });
